var map = {
	"./citations/components/blocks/citations-handle.vue": "8297",
	"./citations/components/blocks/citations-head.vue": "5dcc",
	"./citations/components/citations-module.vue": "b4b5",
	"./citations/components/renderer/CitationsAbbreviations.vue": "28ed",
	"./citations/components/renderer/CitationsList.vue": "7c9a",
	"./citations/components/renderer/CitationsUnordered.vue": "0830",
	"./endpoint/components/endpoint-header.vue": "a781",
	"./endpoint/components/endpoint-navigation.vue": "e59a",
	"./lyra/components/lyra-asset.vue": "bd2f",
	"./lyra/components/lyra-citation.vue": "e9a9",
	"./overlay/components/overlay-module.vue": "4114",
	"./panel/components/panel-module.vue": "813e",
	"./pdfViewer/components/pdf-viewer.vue": "52f9",
	"./pdfViewer/components/pdf.vue": "0aa1",
	"./templates/components/bespoke/efficacy-of-nirmatrelvir.vue": "ead6",
	"./templates/components/bespoke/extrapulmonary-manifestations.vue": "5e12",
	"./templates/components/bespoke/global-covid-cases.vue": "fa18",
	"./templates/components/bespoke/inflammatory-response.vue": "b3bc",
	"./templates/components/bespoke/long-covid-definitions.vue": "3117",
	"./templates/components/bespoke/long-term-outcomes.vue": "c5c5",
	"./templates/components/bespoke/pulmonary-manifestations.vue": "a67a",
	"./templates/components/bespoke/sars-cov-infection-routes.vue": "2a9e",
	"./templates/components/bespoke/sars-cov-variants.vue": "1b7d",
	"./templates/components/builder/template-area.vue": "b7e5",
	"./templates/components/builder/template-content-asset.vue": "ee6f",
	"./templates/components/builder/template-content-bespoke.vue": "5ae7",
	"./templates/components/builder/template-content-content.vue": "a5ab",
	"./templates/components/builder/template-content-image.vue": "fbfe",
	"./templates/components/builder/template-content-svg.vue": "6f12",
	"./templates/components/builder/template-content-video.vue": "3246",
	"./templates/components/template-library.vue": "4f41",
	"./templates/components/template-not-found.vue": "22da",
	"./versions/components/versions-dynamic-view.vue": "76b9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d31d";